require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./hood-river-county-telmate-guardian.json") })
        }
      }, "path---hood-river-county-telmate-guardian");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---hood-river-county-telmate-guardian!./.cache/json/hood-river-county-telmate-guardian.json
// module id = 902
// module chunks = 231608221292675